import React, { useState } from 'react';

import { object, string, number, array } from 'yup';
import * as _ from 'lodash';
import PropertyType from '../PropertyDetailsComponent/PropertyType';
import PropertyPossessionType from '../PropertyDetailsComponent/PropertyPossessionType';
import SuccessPopUP from '../../../UserKyc/UserKYCPopUP/SuccessPopUp';
import ListDirector from '../Director/ListDirector';
import GoogleMap from '../../../../components/GoogleAPI/GoogleAPI';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import LAPTypeSelection from '../../Income/LAPComponents/LAPTypeSelection/LAPTypeSelection';
import LAPPurpose from '../../Income/LAPComponents/LAPPurpose/LAPPurpose';
import { submitPropertyLocationAPI } from '../../../../common/constants/api';
import Modal from '../../../../common/components/Modal/modal';

let allValues = { step: 'LAP' };

export const getAllValues = () => allValues;

const Steps = [
  {
    id: 'LAPTypeSelection',
    component: LAPTypeSelection,
    initialValues: {
      LAPType: '',
      LAPTypeID: ''
    },
    validationSchema: object().shape({
      LAPTypeID: string().required('Required')
    }),

    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'LAPPurpose',
    component: LAPPurpose,
    initialValues: {
      LAPPurpose: '',
      LAPPurposeID: '',
      otherPurpose: ''
    },
    validationSchema: object().shape({
      LAPPurposeID: string().required('Required'),
      otherPurpose: string()
        .when('LAPPurposeID', {
          is: 'OTHERS',
          then: string().required('Required')
        })
        .nullable()
    }),

    onAction: async (sectionValues, formValues) => {}
  },

  {
    id: 'PropertyType',
    component: PropertyType,
    initialValues: {
      propertyID: ''
    },
    validationSchema: object().shape({
      propertyID: string().required('Required')
    }),
    onAction: async (sectionValues, formValues) => {}
  },

  {
    id: 'LapPropertyDetails',
    component: GoogleMap,
    initialValues: {
      house_address: '',
      pin_code: '',
      property_not_identified: '',
      property_identified: '',
      lat: '',
      lng: '',
      city: '',
      state: '',
      notshowBorder: true,
      savedKhataId: ''
    },
    validationSchema: object().shape({
      house_address: string().when('property_identified', {
        is: true,
        then: string()
          .required('Required')
          .min(10, 'Too Short')
      }),
      pin_code: string().when('property_identified', {
        is: true,
        then: string()
          .required('Required')
          .matches(/\d{6}/, 'Pincode should be 6 digit number')
      })
    }),
    onAction: (sectionValues, formValues) => {
      if (sectionValues.property_identified) {
        let address,
          line1 = '',
          line2 = '';
        try {
          address = sectionValues.house_address
            .replace('India,', '')
            .split(',');
        } catch {
          address = '';
        }
        for (let i = 0; i < address.length; i++) {
          if (!address[i].trim()) continue;
          if (
            i < parseInt(parseInt(address.length) / 2) ||
            address.length < 3
          ) {
            line1 += address[i].trim() + ', ';
          } else {
            line2 += address[i].trim() + ', ';
          }
        }
        let submitData = {
          coordinates: {
            latitude: sectionValues.lat,
            longitude: sectionValues.lng
          },
          address: {
            line1: line1 ? line1 : sectionValues.house_address,
            line2: line2,
            city: sectionValues.city,
            state: sectionValues.state,
            pinCode: sectionValues.pin_code
          }
        };

        submitPropertyLocationAPI(getApplicantionInfo().leadId, submitData)
          .then(response => {
            if (response.error) {
              throw new error(response?.data?.message);
            }
          })
          .catch(error => {
            if (error.response) {
              throw new error(error.response?.data?.message);
            }
          });
      }
    }
  },

  {
    id: 'directors',
    component: ListDirector,
    initialValues: {
      relation: { value: '', label: 'Relationship' },
      firstName: '',
      lastName: ''
    },
    validationSchema: object().shape({
      firstName: string().when('isCoOwnerAdding', {
        is: true,
        then: string().required('required')
      }),
      lastName: string().when('isCoOwnerAdding', {
        is: true,
        then: string().required('required')
      }),
      relation: object().when('isCoOwnerAdding', {
        is: true,
        then: object().shape({
          value: string().required('required')
        })
      })
    })
  },
  {
    id: 'PropertyPossessionType',
    component: PropertyPossessionType,
    initialValues: {
      propertyPossessionType: '',
      propertyPossessionID: ''
    },
    validationSchema: object().shape({
      propertyPossessionID: string().required('Required')
    }),
    onAction: async (sectionValues, formValues) => {}
  }
];
export default Steps;
